import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import {
  UPDATE_EVENT_IMAGE,
  CHANGE_EVENT_TITLE,
  UPDATE_QUESTION_TYPE,
  CHANGE_QUESTION_TITLE,
  CHANGE_TIME_LIMIT,
  CHANGE_CHOICE_TITLE,
  UPDATE_CHOICE_IMAGE,
  DELETE_CHOICE_IMAGE,
  CHANGE_ANSWER_CHOICE,
  SEND_EDITOR_INDEX,
  CHANGE_RANKING_CONFIG
} from '../../../actions/editorActions'
import { connect } from 'react-redux'
import EditProblem, { Type } from '../EditProblem/EditProblem'
import EditChoiceSet from '../EditChoiceSet/EditChoiceSet'
import EditFirstPage from '../EditFirstPage/EditFirstPage'
import EditRanking from '../EditRanking/EditRanking'
import TabMenu from '../../molecules/TabMenu/TabMenu'
import TabPane from '../../molecules/TabPane/TabPane'
import { QuestionTypeList, QuestionTimeLimitList, RankingTypeList, QuizType } from '../../../../commons/EditorStatus'

const EditorInput = ({
  project,
  currentEditIndex,
  changeQuestionType,
  changeQuestionTitle,
  changeTimeLimit,
  changeChoiceTitle,
  saveImageInStore,
  deleteImage,
  changeAnswerChoice,
  sendEditorIndex,
  editorIndex,
  quizType,
  rankingConfig,
  showImageUploadModal,
  hideImageUploadModal,
  isModalShow,
  imageUploadTargetIndex,
  changeEventTitleText,
  changeEventImage,
  changeRankingConfig,
  choiceImageErrorMessage,
  eventImageErrorMessage,
  handleDeleteQuestion
}) => {
  const eventTitle = project.presentation_title
  const eventImage = project.image
  const nowQuestion = project.questions[currentEditIndex]
  const questionType = nowQuestion.question_type
  const title = nowQuestion.title
  const limitTime = nowQuestion.limit_time
  const choices = nowQuestion.choices
  const answerChoiceId = nowQuestion.answer_choice_id
  const problemSet = [
    {
      type: Type.TEXTFIELD,
      content: title,
      changeProblem: changeQuestionTitle,
      selectedValue: ''
    },
    {
      type: Type.DROPDOWN,
      content: QuestionTimeLimitList,
      changeProblem: changeTimeLimit,
      selectedValue: limitTime
    }
  ]
  let content
  switch (quizType) {
    case QuizType.FIRSTPAGE.value:
      content = (
        <div>
          <EditFirstPage
            eventTitle={eventTitle}
            onChangeEventTitleText={changeEventTitleText}
            choiceFirstImage={eventImage}
            onChangeFirstImage={changeEventImage}
            errorMessage={eventImageErrorMessage}
          />
        </div>
      )
      break
    case QuizType.QUESTION.value:
      content = (
        <div>
          <TabMenu selected={editorIndex} sendIndex={sendEditorIndex}>
            <TabPane label="問題">
              <EditProblem
                problemSet={problemSet}
                sendIndex={sendEditorIndex}
                isHiddenDeleteButton={project.questions.length === 1}
                handleDeleteQuestion={() =>
                  handleDeleteQuestion({ projectId: project.id, questionId: project.questions[currentEditIndex].id })
                }
              />
            </TabPane>
            <TabPane label="選択肢">
              <EditChoiceSet
                choiceSet={choices}
                saveImageInStore={saveImageInStore}
                deleteImage={deleteImage}
                answerChoiceId={answerChoiceId}
                onChangeAnswerChoice={changeAnswerChoice}
                onChangeQuestionType={changeQuestionType}
                onChangeChoiceTitle={changeChoiceTitle}
                selectedQuestionType={questionType}
                questionTypeCandidate={QuestionTypeList}
                showImageUploadModal={showImageUploadModal}
                hideImageUploadModal={hideImageUploadModal}
                isModalShow={isModalShow}
                imageUploadTargetIndex={imageUploadTargetIndex}
                choiceImageErrorMessage={choiceImageErrorMessage}
              />
            </TabPane>
          </TabMenu>
        </div>
      )
      break
    case QuizType.RANKING.value:
      content = (
        <EditRanking
          onChangeRankingConfig={changeRankingConfig}
          contents={RankingTypeList}
          selectedValue={rankingConfig}
        />
      )
      break
  }
  return content
}

EditorInput.propTypes = {
  problemSet: PropTypes.array,
  project: PropTypes.object,
  currentEditIndex: PropTypes.number,
  answers: PropTypes.array,
  editorIndex: PropTypes.number,
  quizType: PropTypes.number,
  rankingConfig: PropTypes.number,
  handleDeleteQuestion: PropTypes.func,
  toggleImageUploadModal: PropTypes.func,
  isModalShow: PropTypes.bool,
  imageUploadTargetIndex: PropTypes.number,
  choiceImageErrorMessage: PropTypes.string,
  eventImageErrorMessage: PropTypes.string
}

const mapStateToProps = state => {
  return {
    choiceImageErrorMessage: state.editor.choiceImageErrorMessage,
    eventImageErrorMessage: state.editor.eventImageErrorMessage
  }
}

const mapDispatchToProps = dispatch => ({
  changeEventImage: e => dispatch(UPDATE_EVENT_IMAGE(e)),
  changeEventTitleText: e => dispatch(CHANGE_EVENT_TITLE(e)),
  changeQuestionType: e => dispatch(UPDATE_QUESTION_TYPE(e)),
  changeQuestionTitle: e => dispatch(CHANGE_QUESTION_TITLE(e)),
  changeTimeLimit: e => dispatch(CHANGE_TIME_LIMIT(e)),
  changeChoiceTitle: e => dispatch(CHANGE_CHOICE_TITLE(e)),
  saveImageInStore: e => dispatch(UPDATE_CHOICE_IMAGE(e)),
  deleteImage: e => dispatch(DELETE_CHOICE_IMAGE(e)),
  changeAnswerChoice: e => dispatch(CHANGE_ANSWER_CHOICE(e)),
  sendEditorIndex: e => dispatch(SEND_EDITOR_INDEX(e)),
  changeRankingConfig: e => dispatch(CHANGE_RANKING_CONFIG(e))
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  pure
)(EditorInput)
